import { ResourceDetailsMetricKey } from "../types/metrics";
import { ResourceType } from "@/services/cloudchipr.api";

export const metricsHeaderCellTooltips = new Map<
  ResourceType,
  Partial<Record<ResourceDetailsMetricKey, string>>
>([
  [
    "kubernetes_node",
    {
      cpu: "Displays the maximum CPU usage of all scheduled pods on this node over the selected time period, relative to their total requested CPU resources.",
      mem_used:
        "Displays the maximum Memory usage of all scheduled pods on this node over the selected time period, relative to their total requested Memory resources.",
    },
  ],
  [
    "kubernetes_pod",
    {
      cpu: "Represents the highest CPU utilization recorded for the workload over the selected time period, relative to its requested CPU resources.",
      mem_used:
        "Represents the highest Memory utilization recorded for the workload over the selected time period, relative to its requested Memory resources.",
    },
  ],
  [
    "kubernetes_daemon_set",
    {
      cpu: "Represents the highest CPU utilization recorded for the workload over the selected time period, relative to its requested CPU resources.",
      mem_used:
        "Represents the highest Memory utilization recorded for the workload over the selected time period, relative to its requested Memory resources.",
    },
  ],
  [
    "kubernetes_stateful_set",
    {
      cpu: "Represents the highest CPU utilization recorded for the workload over the selected time period, relative to its requested CPU resources.",
      mem_used:
        "Represents the highest Memory utilization recorded for the workload over the selected time period, relative to its requested Memory resources.",
    },
  ],
  [
    "kubernetes_deployment",
    {
      cpu: "Represents the highest CPU utilization recorded for the workload over the selected time period, relative to its requested CPU resources.",
      mem_used:
        "Represents the highest Memory utilization recorded for the workload over the selected time period, relative to its requested Memory resources.",
    },
  ],
]);
